import React from 'react'
import styled from 'styled-components'
import Button, {ButtonProps} from '../button/Button'
import Heading, {HeadingProps} from '../heading/Heading'
import Box from '../layout/Box'
import Centered from '../layout/Centered'
import Container from '../layout/Container'
import Section from '../layout/Section'
import Text, {TextProps} from '../text/Text'

export type CallToActionBackground = 'primaryIndigo' | 'lightBlue'

export interface CallToActionProps {
  background?: CallToActionBackground
  heading?: string
  content?: string
  button?: ButtonProps
  additionalButton?: ButtonProps
}

interface BackgroundWrapperProps {
  $background?: CallToActionBackground
}

const BackgroundWrapper = styled(Box).attrs<BackgroundWrapperProps>(props => ({
  $pt: [32, 90, 90, 90],
  $pb: [64, 120, 120, 120],
  $px: 20,
  $styles: {borderRadius: 16, backgroundColor: props.$background},
}))<BackgroundWrapperProps>({})

const CtaHeading = styled(Heading).attrs<HeadingProps>({
  $variant: ['h3', 'h2', 'h2', 'h2'],
  $mx: 'auto',
  $align: 'center',
  $styles: {
    maxWidth: [null, 740, 740, 740],
  },
})({})

const CtaText = styled(Text).attrs<TextProps>({
  $variant: 'p1',
  $transparency: 0.3,
  $align: 'center',
  $mt: 16,
  $mx: 'auto',
  $styles: {
    maxWidth: [null, 550, 550, 550],
  },
})({})

const CtaButton = styled(Button).attrs<ButtonProps>({
  $buttonType: 'primary',
  $size: 'medium',
  $withArrow: true,
  $mt: 40,
})({})

const CtaAdditionalButton = styled(Button).attrs<ButtonProps>({
  $withArrow: true,
  $size: 'medium',
  $buttonType: 'dark',
  $ml: 8,
})`
  display: inline-block;
`

const CallToAction: React.FC<CallToActionProps> = ({
  background,
  heading,
  content,
  button,
  additionalButton,
  ...props
}) => {
  return (
    <Section as="section" {...props}>
      <Container>
        <BackgroundWrapper $background={background}>
          <Centered>
            {heading && <CtaHeading>{heading}</CtaHeading>}
            {content && <CtaText>{content}</CtaText>}
            {button && <CtaButton {...button} />}
            {additionalButton && <CtaAdditionalButton {...additionalButton} />}
          </Centered>
        </BackgroundWrapper>
      </Container>
    </Section>
  )
}

export default CallToAction
